import { useRef, useState, useEffect } from 'react';
import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiDatepicker,
  RfUiMultiselect,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { arrayToAPI } from 'utils/listUtils';
import { language } from 'utils/literals';
import 'scss/03_generic/literals.scss';
import {
  getTodayFinishDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import {
  getFilterAlumnoValidationRequest,
  removePhotosFilter,
} from 'store/photos/actions';
import { makeSelectAlumnsValidations } from 'store/photos/selectors';
import { formatDateMax } from 'utils/dateTimeUtils';
import { isMobileOnly } from 'react-device-detect';
import { deleteSavedPagination } from 'utils/practiceUtils';
const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  alumno: makeSelectAlumnsValidations(),
} as any);

const mockStates =
  '[{"label":"Pendiente de Validar","value":"PV","active":"false"},{"label":"Rechazada","value":"RZ","active":"false"},{"label":"Validada","value":"VA","active":"false"}]';



const hasMultiselectOptions = (options: any): boolean => {
  if (Array.isArray(options)) {
    return options.length > 0;
  }

  if (typeof options === 'string') {
    try {
      const parsedOptions = JSON.parse(options);

      return Array.isArray(parsedOptions) && parsedOptions.length > 0;
    } catch {
      return false;
    }
  }

  return false;
};


export const ValidationPhotosFilter = ({ handleSubmit }): ReactElement => {
  const dispatch = useDispatch();
  const { profileActive, alumno } = useSelector<any, any>(selectors);

  const [alumnoResetKey, setAlumnoResetKey] = useState(0);
  const resetAlumnoPending = useRef(true);

  const [selectedEstados, setSelectedEstados]: [any, any] = useState('');
  const estado = mockStates;

  //Corregir el estado del filtro selector estados, no era correcto el formato
    const defaultState = () =>
  {

    const estadosArray = JSON.parse(estado);

    if (!estadosArray?.length) {
      return;
    }
    const estadoInit = estadosArray.find((estado) => estado.value === 'PV');
    initEstado.current = estadoInit;

    setSelectedEstados(JSON.stringify([estadoInit]));
  }




  const [selectedAlumns, setSelectedAlumns]: [any, any] = useState('');
  const [selectedFechaDesde, setSelectedFechaDesde]: [any, any] = useState(
    getTodayMinusOneYearStartDate()
  );
  const [selectedFechaHasta, setSelectedFechaHasta]: [any, any] = useState(
    getTodayFinishDate()
  );
  const [errorFechaHasta, setErrorFechaHasta] = useState('');

  const iniFilter = {
    alumno: '',
    estado: '',
    fechaFin: getTodayFinishDate(),
    fechaIni: getTodayMinusOneYearStartDate(),
  };

  const filter: any = useRef(iniFilter);
  const initEstado: any = useRef(null);
  const today = new Date().getTime().toString();

  const handlerSubmitFilters = () => {
    deleteSavedPagination(window.location.pathname);
    handleSubmit(filter.current);
  };

  function handleSelectedEstado(e: any) {
    const estado = arrayToAPI(e.detail);
    filter.current = { ...filter.current, estado };
  }

  //Corregir filtro alumno en validar foto perfil
  const handleStudentSelected = (e: any) => {
    const alumnosSeleccionados = e.detail
      .map((item: any) => item.label?.split(' - ')[1])
      .filter(Boolean)
      .join(',');

    filter.current = { ...filter.current, alumno :alumnosSeleccionados };
  };
  const handleSelectedFechaDesde = (e) => {
    setSelectedFechaDesde(e.detail);
    filter.current.fechaIni = e.detail;
  };

  const handleDateMaxSelected = (e: any) => {
    if (filter.current) {
      setSelectedFechaHasta(formatDateMax(e.detail));
      filter.current.fechaFin = formatDateMax(e.detail);
    }
  };


  const cleanFilters = () => {
    deleteSavedPagination(window.location.pathname);
    dispatch(removePhotosFilter());
    setSelectedEstados('[]');
    setSelectedFechaDesde(getTodayMinusOneYearStartDate());
    setSelectedFechaHasta(getTodayFinishDate());
    setSelectedAlumns('[]');
    filter.current = { ...iniFilter };
    filter.current.estado = defaultState;
    setSelectedEstados(filter.current.estado);
    resetAlumnoPending.current = true;
    dispatch(getFilterAlumnoValidationRequest());
    handleSubmit(filter.current); 
  };

  useEffect(() => {
    if (
      resetAlumnoPending.current &&
      hasMultiselectOptions(alumno)
    ) {
      setAlumnoResetKey(k => k + 1);
      resetAlumnoPending.current = false;
    }
  }, [alumno]);

  useEffect(() => {
    const estadosArray = JSON.parse(estado);

    if (!estadosArray?.length) {
      return;
    }
    const estadoInit = estadosArray.find((estado) => estado.value === 'PV');
    initEstado.current = estadoInit;

    setSelectedEstados(JSON.stringify([estadoInit]));
    filter.current.estado = estadoInit.value;
  }, [estado]);

  useEffect(() => {
    if (selectedFechaDesde && selectedFechaHasta) {
      if (selectedFechaHasta < selectedFechaDesde) {
        setErrorFechaHasta(
          'La fecha de fin no puede ser anterior a la fecha de inicio'
        );
      } else {
        setErrorFechaHasta('');
      }
    } else if (selectedFechaDesde || selectedFechaHasta) {
      setErrorFechaHasta('Debes rellenar la otra fecha');
    } else {
      setErrorFechaHasta('');
    }
  }, [selectedFechaDesde, selectedFechaHasta]);

  useEffect(() => {
    if (profileActive) {
      dispatch(getFilterAlumnoValidationRequest());
    }
  }, [profileActive]);

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>
        <form
          id="photoForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiDatepicker
                moment-locale="es"
                labelInput="Desde"
                disabled={false}
                onDateSelected={(e: any) => {
                  handleSelectedFechaDesde(e);
                }}
                defaultDateFrom={selectedFechaDesde}
                defaultMaxDateFrom={today}
              ></RfUiDatepicker>
            </div>

            <div className="rf-practice-list__input-container">
              <RfUiDatepicker
                moment-locale="es"
                labelInput="Hasta"
                disabled={false}
                onDateSelected={(e: any) => {
                  handleDateMaxSelected(e);
                }}
                defaultDateFrom={selectedFechaHasta}
                defaultMaxDateFrom={today}
              ></RfUiDatepicker>
              <ErrorMessage message={errorFechaHasta}></ErrorMessage>
            </div>
          </div>

          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                textLabel="Estado"
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                placeholder="Seleccione estado"
                defaultChecksRemake={selectedEstados}
                options={estado}
                onOptionSelected={(e: any) => {
                  handleSelectedEstado(e);
                }}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-alumnos-${alumnoResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                multiSelect={true}
                options={alumno}
                //defaultChecks={selectedAlumns}
                defaultChecksRemake={selectedAlumns}
                text-label="Alumno"
                onOptionSelected={handleStudentSelected}
                placeholder="Seleccione alumno"
              />
            </div>
          </div>

          <div
            className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${
               isMobileOnly
                 ? 'rf-block--mobile rf-text-align-center--mobile'
                 : ''
             }`}
          >
            <RfUiButton
              text="Limpiar filtros"
              text-help="Limpiar filtros"
              aspect="secondary"
              onButtonClick={() => {
                cleanFilters();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Filtrar"
              type="button"
              aspect="primary"
              className="rf-button rf-margin-left-30"
              onButtonClick={() => {
                handlerSubmitFilters();
              }}
            >
              {' '}
            </RfUiButton>
          </div>
        </form>
      </RfUiAccordionCustom>
    </>
  );
};
